import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useIntl, intlMessageShape } from 'sb-react-intl'

import messages from './messages'
import s from './CloseIcon.scss'


const CloseIcon = (props) => {
  const {
    className, whiteColor, brandColor, dataToggleOff, dataTestId, selector, id,
    withRemoveLabel, isFocusable = true, ariaLabel,
    onClick,
  } = props

  const intl = useIntl()

  const rootClassName = cx(s.button, className, {
    [s.whiteColor]: whiteColor,
    [s.brandColor]: brandColor,
  })

  const node  = isFocusable ? 'button' : 'div'
  const label = intl.formatMessage(ariaLabel || (withRemoveLabel ? messages.remove : messages.close))

  return React.createElement(
    node,
    {
      className: rootClassName,
      type: isFocusable ? 'button' : null,
      id,
      'data-testid': dataTestId,
      'data-s-toggle-off': dataToggleOff,
      'data-modal-close-id': selector,
      'aria-label': label,
      onClick,
    },
    (
      <div className={cx(s.icon, 'closeIcon')} />
    )
  )
}

CloseIcon.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  whiteColor: PropTypes.bool,
  brandColor: PropTypes.bool,
  withRemoveLabel: PropTypes.bool,
  isFocusable: PropTypes.bool,
  dataTestId: PropTypes.string,
  ariaLabel: PropTypes.shape(intlMessageShape),
  onClick: PropTypes.func,
}


export default CloseIcon
